module.exports = __webpack_public_path__ + "static/media/Plus-blue.f1de6922.svg";